export const AccountContentNegativeKeywordListAssociation = {
  properties: {
    SharedEntityId: {
      'bulk-upload-header': 'Id',
    },
    EntityId: {
      'bulk-upload-header': 'Parent Id',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
    'bulk-upload-type': {
      type: 'string',
      value: 'Account Content Negative Keyword List Association',
    },
  },
};
